import React from "react";
import styled from "styled-components";

interface SizeCounterProps extends React.HTMLAttributes<HTMLDivElement> {
	isInvalid: boolean;
}

export const SizeCounter: React.FC<SizeCounterProps> = ({ isInvalid, children, ...htmlProps }) => {
	return (
		<Container isInvalid={isInvalid} {...htmlProps}>
			{children}
		</Container>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "isInvalid",
})<{ isInvalid: boolean }>`
	text-align: right;
	color: ${({ theme, isInvalid }) => (isInvalid ? theme.colors.red : theme.colors.textTertiary)};
	font-size: 0.8125rem;
`;
